export default __webpack_public_path__ + "static/media/search_icon.2ee84ec1.svg";